const product = {
    getlist: 'product/getlist',
    add: 'product/add',
    update: 'product/update',
    remove: 'product/remove',
    get: 'product/get',
    getall: 'product/getall',
    clearcache: 'product/clear-cache',
}
export default product
